if (!customElements.get('collection-description-toggle')) {
  class CollectionDescriptionToggle extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('.collection-banner__description-text');
      this.btn = this.querySelector('.collection-banner__toggle-btn');
      if (!this.textEl || !this.btn) return;

      // Only show toggle if content is actually clamped
      requestAnimationFrame(() => {
        if (this.textEl.scrollHeight > this.textEl.clientHeight) {
          this.btn.hidden = false;
        }
      });

      this.btn.addEventListener('click', () => this.toggle());
    }

    toggle() {
      const expanded = this.classList.toggle('is-expanded');
      this.btn.textContent = expanded
        ? this.dataset.showLess
        : this.dataset.showMore;
    }
  }
  customElements.define('collection-description-toggle', CollectionDescriptionToggle);
}
